import React from 'react';
import './main-block.scss'
import {useTranslation} from "react-i18next";

function MainBlock() {
    const { t } = useTranslation()
    return <div className="main-block container">
        <div className="main-block__wrapper" data-aos="fade-right">
            <h1 className="main-block__title"><span>{t('main_block.title')}</span> <br/>
                {t('main_block.title2')}</h1>
            <button className="main-block__button button">{t('main_block.button')}</button>
        </div>

        <div className="main-block__text-wrapper" data-aos="fade-up">
            <div className="line">
                <span className="circle"></span>
            </div>
            <span
                className="main-block__text">{t('main_block.description')}</span>
        </div>

    </div>;
}

export default MainBlock;